<script>

    import NormalButton from 'southcn-ui2/src/components/widgets/NormalButton';
    import ModalFooter from 'southcn-ui2/src/components/modals/ModalFooter';
    import NormalInput from 'southcn-ui2/src/components/widgets/NormalInput';
    import NormalFileButton from 'southcn-ui2/src/components/widgets/NormalFileButton';
    import NormalLabel from 'southcn-ui2/src/components/widgets/NormalLabel';
    import ModalHeader from 'southcn-ui2/src/components/modals/ModalHeader';

    const LIMIT = 30;
    export default {
        alias: 'avatarInfo',
        defaultOptions () {
            return {
                title: '个人头像'
            };
        },
        modalCreated (options) {
            for (let key in options) {
                this[key] = options[key];
            }
            this.nickname = this.user.name;
            this.avatarUrl = this.user.avatarUrl;
        },
        data () {
            return {
                title: '',
                nickname: '',
                avatarUrl: '',
                btnText: ['确定', '取消'],
                isDrag: true,
                uploadBtnObj: {
                    icon: '&#xe64e;',
                    text: '上传头像',
                    status: 'before'
                },
                file: null
            };
        },
        name: 'modal-avatar-info',
        computed: {
            user () {
                return this.$store.state.user;
            },
            suffixIcon () {
                return `${this.nickname.length}/${LIMIT}`;
            },
            limitIptError () {
                return this.nickname.length > LIMIT ? 'limit-ipt-error' : '';
            }
        },
        methods: {
            onConfirm () {
                let errortext = '';
                if (this.$util.validate.isEmpty(this.nickname)) {
                    errortext = '请输入昵称';
                } else if (this.nickname.length > LIMIT) {
                    errortext = `昵称超过${LIMIT}个字符`;
                }
                if (errortext) {
                    this.$alias.message.error(errortext);
                    return;
                }
                if (this.file) {
                    this.uploadBtnObj = {
                        icon: '...',
                        text: '上传中',
                        status: 'uploading'
                    };
                }
                this.$api(this.$config.apiUrl.userInfoEdit, {
                    image: this.file,
                    name: this.nickname
                }).then(() => {
                    this.$alias.message.ok(`修改用户信息成功`);
                    this.okCallback && this.okCallback(this.nickname);
                    this.close();
                }).catch(e => {
                    console.log(e)
                    this.uploadBtnObj = {
                        icon: '&#xe64e;',
                        text: '上传头像',
                        status: 'before'
                    };
                    this.$alias.message.error(`修改用户信息失败：${e.errmessage}`);
                });
            },
            onDestroy () {
                if (this.cancelCallback) {
                    this.cancelCallback();
                }
                this.close();
            },
            handleFileChange ($e) {
                const $file = $e[0];
                if (!this.$util.validate.image($file.name)) {
                    this.$alias.message.error('请选择图片上传');
                    return;
                }
                let reader = new FileReader();
                reader.readAsDataURL($file);
                reader.onload = (e) => {
                    this.avatarUrl = e.target.result;
                };
                this.file = $file;
            }
        },
        components: {
            ModalHeader,
            NormalButton,
            ModalFooter,
            NormalInput,
            NormalFileButton,
            NormalLabel
        },
        mounted () {

        }
    };
</script>

<template>
    <div class="modal">
        <modal-header :text="title" :is-drag="true"></modal-header>
        <div class="modal-content">
            <div class="row">
                <normal-label class="avatar-label">头像</normal-label>
                <div class="avatar-wrapper" :class="uploadBtnObj.status">
                    <img :src="avatarUrl" alt="用户头像"/>
                    <normal-file-button @change="handleFileChange" class="hide"></normal-file-button>
                    <div class="avatar-mask">
                        <span class="icon" v-html="uploadBtnObj.icon"></span>
                        <span class="text">{{uploadBtnObj.text}}</span>
                    </div>
                </div>
            </div>
            <div class="row nickname" style="display: none">
                <normal-label>用户昵称</normal-label>
                <normal-input class="input"
                              :class="limitIptError"
                              v-model="nickname"
                              :suffix-icon="suffixIcon"
                ></normal-input>
            </div>
        </div>
        <modal-footer>
            <normal-button @click="onConfirm();"
                           class="modal-footer-btn__center"
                           float="right"
                           :text="btnText[0] || '确定'"
                           theme="blue"
            ></normal-button>
            <normal-button @click="onDestroy();"
                           class="modal-footer-btn__center"
                           float="right"
                           :margin-right="2"
                           :text="btnText[1] || '取消'"
                           theme="grey"
            ></normal-button>
        </modal-footer>
    </div>
</template>

<style lang="less" scoped>
    @import '../../../southcn-ui2/src/assets/less/widgets-var.less';

    .modal {
        .modal-style;
        min-height: 400px;
        height: auto;
        width: 560px;

        * {
            box-sizing: border-box;
        }

        .limit-ipt-error {
            ::v-deep {
                .normal-input__suffix {
                    color: @dangerBg;
                }
            }
        }

        .row {
            &.nickname {
                margin-top: 14px;
            }

            .avatar-label {
                margin-top: 50px;
            }

            .avatar-wrapper {
                width: 140px;
                float: left;
                height: 140px;
                position: relative;

                &.uploading {
                    .avatar-mask {
                        display: block;
                    }
                }

                &.before {
                    .avatar-mask {
                        display: none;
                    }

                    &:hover {
                        .avatar-mask {
                            display: block;
                        }
                    }
                }

                img {
                    width: 140px;
                    height: 140px;
                    border-radius: 3px;
                }

                .avatar-mask {
                    z-index: 33;
                    background: rgba(0, 0, 0, 0.6);
                    opacity: 1;
                }

                span {
                    display: inline-block;
                    width: 100%;
                    color: #fff;
                    text-align: center;
                }

                .icon {
                    font-family: cmsicon;
                    font-size: @fontSizeTitle;
                    margin: 42px 0 10px 0;
                }

                .text {
                    font-size: @fontSizeeBtnTableText
                }
            }

            .hide, .avatar-mask {
                position: absolute;
                width: 140px;
                height: 140px;
                left: 0;
                top: 0;
                opacity: 0;
                z-index: 99;
                box-sizing: border-box;
                margin: 0;
            }

            .label {
                width: 126px;
            }

            .input {
                width: 380px;

                ::v-deep {
                    input {
                        padding-right: 50px;
                    }

                    .normal-input__suffix {
                        width: 30px;
                        right: 10px;
                        font-size: 12px;
                    }
                }

            }


        }

        .modal-content {
            padding: 41px 0;
        }
    }
</style>
